import * as React from "react"
import { BackPill } from "@digits-shared/DesignSystem/BackButtonPill"
import fonts from "@digits-shared/themes/typography"
import styled from "styled-components"
import { IconContainer } from "src/frontend/components/Shared/Glow/Icon"

const StyledTitle = styled.h1`
  display: flex;
  align-items: center;
  gap: 16px;
  margin: 0;
  font-size: 18px;
  font-weight: ${fonts.weight.heavy};
`

export const Header: React.FC<
  React.PropsWithChildren<{
    onBack?: () => void
    to?: string
    disabled?: boolean
    icon?: React.ReactNode
  }>
> = ({ onBack, to, disabled, icon, children }) => (
  <>
    {(onBack || to) && <BackPill onClick={onBack} to={to} disabled={disabled} />}
    <Title icon={icon}>{children}</Title>
  </>
)

export const Title: React.FC<React.PropsWithChildren<{ icon?: React.ReactNode }>> = ({
  children,
  icon,
}) => (
  <StyledTitle>
    {icon && <IconContainer>{icon}</IconContainer>}
    {children}
  </StyledTitle>
)
